import React from 'react';
import { Employee } from '../../../types';
import { positionForLanguage } from '../../../utils/employeeName';

interface QuickCrewTableProps {
  filteredEmployees: Employee[];
  selectedEmployees: string[];
  onToggle: (employeeId: string) => void;
  onSelectAll: () => void;
  language?: 'ar' | 'en';
  nameFor?: (employee?: Employee | null) => string;
}

const HEADERS = {
  en: { code: 'Code', name: 'Name', position: 'Position', department: 'Department', seamanBook: 'Seaman Book', exp: 'Exp' },
  ar: { code: 'الكود', name: 'الاسم', position: 'الوظيفة', department: 'القسم', seamanBook: 'الجواز البحري', exp: 'انتهاء' },
};

const QuickCrewTable: React.FC<QuickCrewTableProps> = ({
  filteredEmployees,
  selectedEmployees,
  onToggle,
  onSelectAll,
  language = 'en',
  nameFor
}) => {
  const h = HEADERS[language];
  const displayName = nameFor || ((emp?: Employee | null) => emp?.name || '');
  return (
    <div className="border rounded-lg overflow-hidden">
      <div className="max-h-96 overflow-y-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50 sticky top-0">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                <input
                  type="checkbox"
                  checked={selectedEmployees.length === filteredEmployees.length && filteredEmployees.length > 0}
                  onChange={onSelectAll}
                  className="h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300 rounded"
                />
              </th>
              <th className="px-6 py-3 text-start text-xs font-medium text-gray-500 uppercase tracking-wider">
                {h.code}
              </th>
              <th className="px-6 py-3 text-start text-xs font-medium text-gray-500 uppercase tracking-wider">
                {h.name}
              </th>
              <th className="px-6 py-3 text-start text-xs font-medium text-gray-500 uppercase tracking-wider">
                {h.position}
              </th>
              <th className="px-6 py-3 text-start text-xs font-medium text-gray-500 uppercase tracking-wider">
                {h.department}
              </th>
              <th className="px-6 py-3 text-start text-xs font-medium text-gray-500 uppercase tracking-wider">
                {h.seamanBook}
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {filteredEmployees.map((employee) => (
              <tr key={employee.id} className="hover:bg-gray-50">
                <td className="px-6 py-4 whitespace-nowrap">
                  <input
                    type="checkbox"
                    checked={selectedEmployees.includes(employee.id)}
                    onChange={() => onToggle(employee.id)}
                    className="h-4 w-4 text-primary-600 focus:ring-primary-500 border-gray-300 rounded"
                  />
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                  {employee.code}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {displayName(employee)}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {positionForLanguage(employee, language) || '-'}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {employee.department || '-'}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {employee.seamanBookNumber || '-'}
                  {employee.seamanBookExpiry && (
                    <div className="text-xs text-gray-500">
                      {h.exp}: {new Date(employee.seamanBookExpiry).toLocaleDateString(language === 'ar' ? 'ar-EG' : undefined)}
                    </div>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default QuickCrewTable;
